import { useQuery } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";

const GET_CUSTOM_REPORT_CONTENT_FETCH_KEY = "GET_CUSTOM_REPORT_CONTENT_KEY";

const REFRESH_MS = 10 * 60 * 1000;

export interface CustomReportContent {
  html: string;
  updatedAt: string | null;
}

export const getCustomReportContent = async (
  id: string,
): Promise<CustomReportContent> => {
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/custom-reports/${id}/content`,
  );
  return response.data;
};

export const useGetCustomReportContent = (id: string | null) => {
  const { data, isPending, error } = useQuery({
    queryKey: [GET_CUSTOM_REPORT_CONTENT_FETCH_KEY, id],
    queryFn: () => getCustomReportContent(id as string),
    enabled: Boolean(id),
    refetchInterval: REFRESH_MS,
  });

  return { data, isPending, error };
};
